import { Chip } from "@mui/material";
import { getTagChipColor } from "../utils/tag-utils";

interface TagChipsProps {
  tags: string[];
  marginRight?: string;
  onDelete?: (tags: string[]) => void;
  size?: "small" | "medium";
}

export default function TagChips(props: TagChipsProps) {
  return (
    <>
      {props.tags &&
        props.tags.map((t, index) => (
          <Chip
            key={`tag-${index}-${t}`}
            label={t}
            size={props.size || "small"}
            color={getTagChipColor(t)}
            sx={{ marginRight: props.marginRight || "0.2em" }}
            onDelete={props.onDelete ? () => props.onDelete([t]) : undefined}
          />
        ))}
    </>
  );
}
